<template lang="pug">
  section.participa-help-panel
    table
      thead
        tr
          th(colspan="3")
            span Guía de Navegación
      tbody
        tr
          td
            .how-to-panel
              i.ap-guide-filter
              span.how-to-panel-explain Seleccione los proyectos según sus tipos y fases.
          td
            .how-to-panel
              i.ap-guide-timeline
              span.how-to-panel-explain Seleccione un año para ver las actuales y proyectadas de los proyectos.
          td
            .how-to-panel
              i.ap-guide-markers
              span.how-to-panel-explain Seleccione mapa para ver la ubicación y detalles de los proyectos.

</template>

<script>
export default {
  name: 'HelpPanel'
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

$icon-size = 2rem
$icon-padding-right = $f5px

.participa-help-panel
  color: white
  display: inline-block
  width: $help-panel-width
  top: $header-height
  table
    border-collapse: collapse
    width: 100%
  td, th
    border: $f1px solid white
    padding: $f3px
.how-to-panel
  i
    display: inline-block
    font-size: $icon-size
    padding-right: $icon-padding-right
    vertical-align: super
  span
    display: inline-block
    width: "calc(100% - %s)" % ($icon-size + $icon-padding-right + .2rem)

</style>
